// Actions
export const FOCUS_FORM_CONTROL = 'FOCUS_FORM_CONTROL';
export const BLUR_FORM_CONTROL = 'BLUR_FORM_CONTROL';

// Reducer
export default function formControlReducer(state = null, action) {
  const { type, payload } = action;
  switch (type) {
    case FOCUS_FORM_CONTROL:
      return payload;
    case BLUR_FORM_CONTROL:
      return null;
    default:
      return state;
  }
}

// Action Creators
export function focusFormControl(payload) {
  return { type: FOCUS_FORM_CONTROL, payload };
}

export function blurFormControl() {
  return { type: BLUR_FORM_CONTROL };
}



// WEBPACK FOOTER //
// ./src/redux/modules/formControl.js